<template>
  <span v-if="band">
    <v-chip
      v-if="chip"
      color="deep-orange darken-2"
      text-color="white"
      :x-small="small"
      :small="!small"
      class="band-indicator-chip"
      :title="band.label"
    >
      <v-icon left :x-small="small" :small="!small">mdi-link-variant</v-icon>
      BAND {{ band.units }}
    </v-chip>
    <v-alert
      v-else
      dense
      outlined
      type="warning"
      icon="mdi-link-variant"
      class="band-indicator-banner mb-2"
    >
      <strong>{{ band.label }}</strong>
      <div class="text-caption">
        Strap all {{ band.units }} units into one package (no box).
        <span v-if="dims">Banded size: {{ dims }}.</span>
      </div>
    </v-alert>
  </span>
</template>

<script>
import { bandInfo, bandDimensions } from "@/utils/band.mjs";

export default {
  name: "BandIndicator",
  props: {
    shipment: {
      type: Object,
      default: null,
    },
    chip: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    band() {
      return bandInfo(this.shipment);
    },
    dims() {
      return bandDimensions(this.shipment);
    },
  },
};
</script>
